import { queryOptions } from '@tanstack/react-query'

import { UserType } from '@/entities/user'
import { PaginationSearchParams } from '@/shared/api'

import { getNotices } from './get-notices'

export const supportQueries = {
  all: () => ['support'],
  notices: (userType: UserType, searchParams: PaginationSearchParams) =>
    queryOptions({
      queryKey: [...supportQueries.all(), 'notices', userType, searchParams],
      queryFn: () => getNotices({ userType, searchParams }),
    }),
}
